export default "/assets/fonts/Graphik-Regular.934701dfcda2640bb8246d811f708016.woff2";